<bl-modal-content
  #content
  [title]="'商談メモ定型文選択'"
  [footerButtonType]="modalButtonType.OkCancel"
  [disableOkButton]="selectedData === null"
>
  <div body>
    <bl-table
      [addClass]="'table-bordered table-hover'"
      [headers]="headers"
      [datas]="dealsMemoFixedFormatSettingList"
      [maxHeight]="'calc(100vh - 350px)'"
      [displayEmptyMessage]="true"
      [selectable]="true"
      (selectRowEvent)="onChangeSelectedRow($event)"
    ></bl-table>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/page/profile-entries-page/fixed-format-memo-modal/fixed-format-memo-modal.component.html